import { Heading, Stack, Text } from "@chakra-ui/react";
import { Auth } from "aws-amplify";
import { useNavigate } from "react-router-dom";
import { MutedLink } from "../../../components/shared/MutedLink";
import { Routes } from "../../../constants";
import AuthRegisterDemoForm from "../forms/AuthRegisterDemoForm";
import { IUserProfile } from "../../../models/UserProfile";
import { useCreateUserProfile } from "../../../services/api/userProfiles/mutations/useCreateUserProfile";

export interface RegisterError {
  key?: string;
  status: string;
}

const AuthRegister = () => {
  const navigate = useNavigate();

  // const userSignUp = state.userSignUp;
  const {
    mutateAsync: mutateAsyncCreateUserProfile,
  } = useCreateUserProfile();

  const handleFormSubmit = async (firstName: string, lastName: string, username: string, password: string) => {
    try {
      const cognitoUser  = await Auth.signUp({username, password});

      const userSignUp: IUserProfile = {
        email: username,
        id: cognitoUser.userSub,
        first_name: firstName,
        last_name: lastName
      }
      
      const currentURL = window.location.href;

      let registerDemo: boolean = false
      let organizationId: string = ""
      if (currentURL.split("/").at(-1) === "register") {
        registerDemo = true
      } else {
        organizationId = currentURL.split("/").at(-1) || ""
      }

      try {
        console.log("hit backend ")
        await mutateAsyncCreateUserProfile({organizationId, registerDemo, userSignUp});
      } catch (err) {
        console.log(err);
        // Throw error for downstream form to handle
        throw err;
      }

      let goToEmailConfirmationUrl: string = Routes.AuthEmailConfirmation;

      navigate(goToEmailConfirmationUrl, {
        state: { username }
      });
    }
    catch (error: any) {
      let err: RegisterError = {
        status: "Account creation failed",
      };
      if (error.code === "UsernameExistsException") {
        err = {
          key: "email",
          status: "An account with the given email already exists",
        };
      }
      throw err;
    }

  };

  return (
    <Stack spacing={16}>
      <Stack>
        <Heading color={"text.main"} as="h1" size="xl">
          Register
        </Heading>
        <Text color={"text.softer"} fontSize="xl">
          Welcome to Geneial! Please create your account to get started.
        </Text>
      </Stack>

      {/* Form */}
      <Stack spacing={6}>
        {/* ResetPassword Form */}
        <AuthRegisterDemoForm
          handleFormSubmit={handleFormSubmit}
        ></AuthRegisterDemoForm>

        {/* Actions */}
        <Stack>
          {/* Back to login */}
          <MutedLink
            to={Routes.AuthSignIn}
            label="back to sign in"
            iconName="arrow_back"
          ></MutedLink>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default AuthRegister;
